import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import MDXRenderer from 'gatsby-plugin-mdx/mdx-renderer';
import { MDXProvider } from '@mdx-js/react';
import HeroSection from '../components/HeroSection';
import Section from '../components/Section';
import Link from '../components/Link';
import Blockquote from '../components/Blockquote';
import List from '../components/List';
import ListItem from '../components/ListItem';
import Breakline from '../components/Breakline';
import { TableContainer, TableRow, TableHeaderCell, TableDataCell } from '../components/Table/Table';

const components = {
    a: Link,
    blockquote: Blockquote,
    ul: List,
    ol: styled(List).attrs({ variant: 'ordered' })``,
    li: ListItem,
    hr: Breakline,
    table: TableContainer,
    tr: TableRow,
    th: TableHeaderCell,
    td: TableDataCell
};

const BaseMdxLayout = ({
    heroContent,
    children,
    useRenderer
}) => {

    const Wrapper = useRenderer ? MDXRenderer : React.Fragment;

    return (
        <MDXProvider components={components}>
            <HeroSection paddingTop="8px">
                {heroContent}
            </HeroSection>

            <Section
                backgroundColor="white"
                paddingTop="78px"
                paddingBottom="164px"
            >
                <div
                    css={`
                        max-width: 800px;
                    `}
                >
                    <Wrapper>{children}</Wrapper>
                </div>
            </Section>
        </MDXProvider>
    );
};

BaseMdxLayout.propTypes = {
    heroContent: PropTypes.node,
    children: PropTypes.node,
    useRenderer: PropTypes.bool
};

BaseMdxLayout.defaultProps = {
    useRenderer: true
};

export default BaseMdxLayout;
